import React from 'react';
import Box from '@mui/material/Box';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';

import { useTreeItem } from '@mui/x-tree-view/useTreeItem';
import {
  TreeItemContent,
  TreeItemIconContainer,
  TreeItemGroupTransition,
  TreeItemLabel,
  TreeItemRoot,
  TreeItemCheckbox,
} from '@mui/x-tree-view/TreeItem';
import { TreeItemIcon } from '@mui/x-tree-view/TreeItemIcon';
import { TreeItemProvider } from '@mui/x-tree-view/TreeItemProvider';
import { TreeItemDragAndDropOverlay } from '@mui/x-tree-view/TreeItemDragAndDropOverlay';
import LabelIcon from '@mui/icons-material/Label';

const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
  const { id, itemId, label, disabled, children, ...other } = props;

  const {
    getContextProviderProps,
    getRootProps,
    getContentProps,
    getIconContainerProps,
    getCheckboxProps,
    getLabelProps,
    getGroupTransitionProps,
    getDragAndDropOverlayProps,
    status,
  } = useTreeItem({ id, itemId, children, label, disabled, rootRef: ref });

  return (
    <TreeItemProvider {...getContextProviderProps()}>
      <TreeItemRoot {...getRootProps(other)}>
        <TreeItemContent {...getContentProps()}>
          
          <Box sx={{ flexGrow: 1, display: 'flex', gap: 1 }}>
            <LabelIcon style={{color:'#777777'}} />
            <TreeItemCheckbox {...getCheckboxProps()} />
            <TreeItemLabel 
              sx={{
                fontSize: '0.9rem',
                fontWeight: 500,
                color: '#666666'
              }}
              {...getLabelProps()} 
            />
          </Box>
          <TreeItemIconContainer {...getIconContainerProps()}>
            <TreeItemIcon status={status} />
          </TreeItemIconContainer>
          <TreeItemDragAndDropOverlay {...getDragAndDropOverlayProps()} />
        </TreeItemContent>
        {children && <TreeItemGroupTransition {...getGroupTransitionProps()} />}
      </TreeItemRoot>
    </TreeItemProvider>
  );
});

function getItemUrl(url) {
  if(url.indexOf('#none$',0)<0) {
    document.location.href=global.config.urlOrigin+"/"+url;
  }
}

function getParent(data, currpage) {
  var resultPages = '';
  data.forEach((res) => {
    if(res.children !== undefined) {
      var isFound = res.children.filter((reschild) =>  {
        return reschild.id === currpage;
      });
      if(isFound.length > 0) { resultPages = res.id; }
    }
  });
  return resultPages; 
}
function listMenu() {
  var dataMenu = [];
  var dataSubMenu = [];
  dataMenu.push({ id: 'internalportal', label: 'Dashboard' });
  if((localStorage.getItem('ulevel') === global.config.userlevel[0])  || (JSON.parse(localStorage.getItem('urole'))[0] !== undefined && JSON.parse(localStorage.getItem('urole'))[0] === "ON") || (JSON.parse(localStorage.getItem('urole'))[1] !== undefined && JSON.parse(localStorage.getItem('urole'))[1] === "ON") || (JSON.parse(localStorage.getItem('urole'))[7] !== undefined && JSON.parse(localStorage.getItem('urole'))[7] === "ON")) {
    dataMenu.push({ id: 'iclients', label: 'Client' });
  } 
  if((localStorage.getItem('ulevel') === global.config.userlevel[0])  || (JSON.parse(localStorage.getItem('urole'))[1] !== undefined && JSON.parse(localStorage.getItem('urole'))[1] === "ON")) {
    dataSubMenu = [];
    if(localStorage.getItem('ulevel') === global.config.userlevel[0]) {
      dataSubMenu.push({ id: 'ilicencetypes', label: 'SKU Licence' })
    }
    dataSubMenu.push({ id: 'ilicenceexpired', label: 'Licence Expired'})
    dataMenu.push({ id: '#none$1', label: 'Licences', children: dataSubMenu });
  }
  if((localStorage.getItem('ulevel') === global.config.userlevel[0])  || (JSON.parse(localStorage.getItem('urole'))[1] !== undefined && JSON.parse(localStorage.getItem('urole'))[1] === "ON")) {
    dataMenu.push({ id: '#none$5', label: 'Notification', children: [
        { id: 'isendnotification', label: 'Send Notification' },
        { id: 'ilognotification', label: 'Log Notification'},
      ] 
    });
  }
  if((localStorage.getItem('ulevel') === global.config.userlevel[0])  || (JSON.parse(localStorage.getItem('urole'))[5] !== undefined && JSON.parse(localStorage.getItem('urole'))[5] === "ON") || (JSON.parse(localStorage.getItem('urole'))[7] !== undefined && JSON.parse(localStorage.getItem('urole'))[7] === "ON")) {

    dataMenu.push({ id: '#none$2', label: 'Client`s Request', children: [
        { id: 'iaddlicence', label: 'Add Licence Request' },
        { id: 'irenewlicence', label: 'Renewal Licence Request'},
        { id: 'iclaimgcp', label: 'Claim GCP Request'},
        { id: 'iupgradelicence', label: 'Upgrade Licence Request'},
        { id: 'itraining', label: 'Training Session Request'},
      ] 
    });
  }
  if((localStorage.getItem('ulevel') === global.config.userlevel[0])  || (JSON.parse(localStorage.getItem('urole'))[5] !== undefined && JSON.parse(localStorage.getItem('urole'))[5] === "ON")  || (JSON.parse(localStorage.getItem('urole'))[6] !== undefined && JSON.parse(localStorage.getItem('urole'))[6] === "ON")) {
    dataMenu.push({ id: 'iaddcontent', label: 'Content Insight' });
  }
  if((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[5] !== undefined && JSON.parse(localStorage.getItem('urole'))[5] === "ON")) {
    dataSubMenu = [];
    dataSubMenu.push({ id: 'iclientmessages', label: 'Contact Us' });
    if(localStorage.getItem('ulevel') === global.config.userlevel[0]) {
      dataSubMenu.push({ id: 'iclientchathistory', label: 'Helpdesk'})
    }
    dataMenu.push({ id: '#none$3', label: 'Message From Clients', children: dataSubMenu });
  }
  if((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[8] !== undefined && JSON.parse(localStorage.getItem('urole'))[8] === "ON")) {
    dataSubMenu = [];
    dataSubMenu.push({ id: 'izte', label: 'Register ZTE' });
    if(localStorage.getItem('ulevel') === global.config.userlevel[0]) {
      dataSubMenu.push({ id: 'iztedel', label: 'Delete ZTE'});
    }
    dataSubMenu.push({ id: 'iztelog', label: 'Log ZTE'});
    dataMenu.push({ id: '#none$4', label: 'ZTE', children: dataSubMenu });
  }

  if((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[9] !== undefined && JSON.parse(localStorage.getItem('urole'))[9] === "ON")) {
    dataSubMenu = [];
    dataSubMenu.push({ id: 'igcpbudget', label: 'Client`s Budget GCP' });
    dataSubMenu.push({ id: 'igcpbudgetmsgtemplate', label: 'Template Alert' });
    dataMenu.push({ id: '#none$6', label: 'Budgeting GCP Billing', children: dataSubMenu });
  }
  
    dataMenu.push({ id: 'iextdrive', label: 'External Shared Drive' });
  if(localStorage.getItem('ulevel') === global.config.userlevel[0]) {
    dataMenu.push({ id: 'imembers', label: 'Member' });
  }
    dataMenu.push({ id: 'imyprofile', label: 'My Profile' });
  return dataMenu;
}


export default function ISidemenu() {
  var geturl = window.location.pathname; 
  var arrLink = geturl.split('/');
  var currpages = arrLink[1];

  var treeData = listMenu();
  var lv1pages = getParent(treeData, currpages);
  return (
    <div className="sidebar-content">
      <div className="smLeftMenu">MAIN MENU</div>
      <div>
        {
          (lv1pages !== undefined)? 
            <Box sx={{ minHeight: 200, minWidth: 250 }}>
                      <RichTreeView
                        defaultExpandedItems={[lv1pages]}
                        defaultSelectedItems={currpages}
                        items={treeData}
                        slots={{ item: CustomTreeItem }}
                        onItemClick={(event, item) => getItemUrl(item)}
                      />
            </Box>
          : <></>
        }
        
      </div>
      
      <div><p><br/><br/></p></div>
    </div>
  );
}
